const RECENT_TAGS_KEY = 'tagSearchRecent';
const TAG_COUNTS_KEY = 'tagSearchCounts';

const safeParse = <T,>(value: string | null, fallback: T): T => {
    if (!value) return fallback;
    try {
        return JSON.parse(value) as T;
    } catch {
        return fallback;
    }
};

export const getRecentTags = (limit: number): string[] => {
    const recent = safeParse<string[]>(localStorage.getItem(RECENT_TAGS_KEY), []);
    return Array.isArray(recent) ? recent.slice(0, limit) : [];
};

export const getFrequentTags = (limit: number): string[] => {
    const counts = safeParse<Record<string, number>>(localStorage.getItem(TAG_COUNTS_KEY), {});
    return Object.entries(counts)
        .sort((a, b) => b[1] - a[1])
        .map(entry => entry[0])
        .slice(0, limit);
};

export const recordTagUse = (tag: string, limit: number): { recent: string[]; frequent: string[] } => {
    const normalized = tag.trim().toLowerCase();
    if (!normalized) {
        return { recent: [], frequent: [] };
    }
    const recentRaw = safeParse<string[]>(localStorage.getItem(RECENT_TAGS_KEY), []);
    const counts = safeParse<Record<string, number>>(localStorage.getItem(TAG_COUNTS_KEY), {});

    const nextRecent = [normalized, ...recentRaw.filter(item => item !== normalized)].slice(0, limit);
    counts[normalized] = (counts[normalized] || 0) + 1;

    localStorage.setItem(RECENT_TAGS_KEY, JSON.stringify(nextRecent));
    localStorage.setItem(TAG_COUNTS_KEY, JSON.stringify(counts));

    return {
        recent: nextRecent,
        frequent: Object.entries(counts)
            .sort((a, b) => b[1] - a[1])
            .map(entry => entry[0])
            .slice(0, limit)
    };
};
